export const EVENT_INTERSECTION     = 'intersection';
export const EVENT_INTERSECTION_IN  = 'intersection:in';
export const EVENT_INTERSECTION_OUT = 'intersection:out';